import { AdminOnboarding } from '../../components/journey/admin/AdminOnboarding';
import React, { useEffect, useState } from 'react';
import { Toaster } from '../../components/ui/sonner';
import { toast } from 'sonner';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { adminApi, adminLogin, adminToken } from './journeyApi';
import { AdminStudents } from '../../components/journey/admin/AdminStudents';
import { AdminReviews } from '../../components/journey/admin/AdminReviews';
import { AdminCheckins } from '../../components/journey/admin/AdminCheckins';
import { AdminOpportunities } from '../../components/journey/admin/AdminOpportunities';
import { AdminPrograms } from '../../components/journey/admin/AdminPrograms';
import { AdminCatalog } from '../../components/journey/admin/AdminCatalog';

const PinLogin = ({ onDone }) => {
  const [pin, setPin] = useState('');
  const submit = async (e) => {
    e.preventDefault();
    try {
      const r = await adminLogin(pin);
      sessionStorage.setItem('admin_token', r.token);
      onDone();
    } catch (err) { toast.error(err.message); }
  };
  return (
    <div className="min-h-screen bg-[#0b1f4d] flex items-center justify-center p-6" data-testid="journey-admin-login">
      <form onSubmit={submit} className="bg-white rounded-2xl p-8 w-full max-w-sm">
        <p className="font-outfit text-2xl font-bold text-[#0b1f4d]">Consultant console</p>
        <p className="text-sm text-slate-500 mt-1 mb-6">Elevate Journey prototype · use your admin PIN</p>
        <input type="password" value={pin} onChange={(e) => setPin(e.target.value)} placeholder="Admin PIN" data-testid="journey-admin-pin-input"
          className="w-full border border-slate-200 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-teal-500" />
        <button className="mt-4 w-full bg-[#0b1f4d] text-white font-semibold py-3 rounded-full" data-testid="journey-admin-login-btn">Sign in</button>
      </form>
    </div>
  );
};

const TABS = [['students', 'Students', AdminStudents], ['onboarding', 'Onboarding', AdminOnboarding], ['reviews', 'Review queue', AdminReviews], ['checkins', 'Check-ins', AdminCheckins],
  ['opportunities', 'Opportunities', AdminOpportunities], ['programs', 'Programs & pricing', AdminPrograms], ['catalog', 'Roles & missions', AdminCatalog]];

export default function JourneyAdmin() {
  const [authed, setAuthed] = useState(!!adminToken());
  const [catalog, setCatalog] = useState(null);

  useEffect(() => {
    if (!authed) return;
    adminApi('/catalog').then(setCatalog).catch((e) => { if (e.status === 401) { sessionStorage.removeItem('admin_token'); setAuthed(false); } else toast.error(e.message); });
  }, [authed]);

  if (!authed) return <><Toaster richColors position="top-center" /><PinLogin onDone={() => setAuthed(true)} /></>;
  return (
    <div className="min-h-screen bg-[#f7f6f2] font-inter text-slate-800" data-testid="journey-admin">
      <Toaster richColors position="top-center" />
      <header className="bg-[#0b1f4d] text-white px-6 lg:px-10 py-5 flex flex-wrap items-center justify-between gap-3">
        <div><p className="font-outfit font-bold text-lg">Elevate Journey · <span className="text-teal-300">Consultant console</span></p>
          <p className="text-xs text-slate-400">Prototype · demo personas · simulated payments · emails are preview-only</p></div>
        <a href="/demo" className="text-sm text-teal-300" data-testid="admin-open-student-view">Open student view →</a>
      </header>
      <main className="px-4 sm:px-6 lg:px-10 py-8">
        {!catalog ? <div className="h-40 bg-white rounded-2xl animate-pulse" /> : (
          <Tabs defaultValue="students">
            <TabsList className="flex-wrap h-auto bg-white border border-slate-200 rounded-full p-1 mb-6">
              {TABS.map(([id, label]) => <TabsTrigger key={id} value={id} className="rounded-full data-[state=active]:bg-[#0b1f4d] data-[state=active]:text-white" data-testid={`admin-tab-${id}`}>{label}</TabsTrigger>)}
            </TabsList>
            {TABS.map(([id, , C]) => <TabsContent key={id} value={id}><C catalog={catalog} setCatalog={setCatalog} /></TabsContent>)}
          </Tabs>)}
      </main>
    </div>
  );
}
